export default "__VITE_ASSET__cee557fb__"